import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';

export const PageStyles = styled(OnboardingPage)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    pointer-events: none;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 0 0 26px;
    }

    .onboarding-options-list {
      margin-top: 24px;
    }
  }
`;

export const SubtitleStyles = styled.p`
  font-family: Poppins;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0;
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin-bottom: 0;
  font-family: Poppins;
  font-weight: 600;
  font-style: Italic;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
`;
